<template>
	<v-container class="pa-2 pa-sm-3" max-width="1200">
		<v-alert v-if="status.error" type="error" class="mb-3" variant="tonal" density="compact">
			{{ status.error }}
		</v-alert>

		<div class="d-flex align-center mb-2">
			<SideSelector />
			<v-spacer />
		</div>

		<RoomCard class="mb-2" />

		<SideCard :key="selectedSide" :side="selectedSide" />

		<div class="text-caption text-medium-emphasis text-center my-3 d-flex align-center justify-center flex-wrap ga-2">
			<span>updated {{ lastFetched }} · {{ liveLabel }}</span>
			<v-btn variant="text" size="x-small" prepend-icon="mdi-refresh" :loading="refreshing" @click="forceRefresh">Refresh</v-btn>
		</div>
	</v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import statusStore from "../stores/statusStore.js";
import RoomCard from "../components/RoomCard.vue";
import SideCard from "../components/SideCard.vue";
import SideSelector from "../components/SideSelector.vue";
import { useSelectedSide } from "../composables/useSelectedSide.js";

var status = statusStore;
var d = computed(() => statusStore.data.data);
var selectedSide = useSelectedSide();
var refreshing = ref(false);

async function forceRefresh() {
	refreshing.value = true;
	try { await statusStore.methods.tickNow(); }
	finally { refreshing.value = false; }
}

var lastFetched = computed(() => {
	if (!statusStore.data.lastFetched) { return "never"; }
	return new Date(statusStore.data.lastFetched).toLocaleTimeString();
});

var liveLabel = computed(() => {
	var m = d.value?.useMocks ?? {};
	var mocked = [];
	var live = [];
	for (var [k, name] of [["sleepme", "SleepMe"], ["smartthings", "SmartThings"], ["sleepiq", "SleepIQ"]]) {
		(m[k] ? mocked : live).push(name);
	}
	if (!mocked.length) { return "all live"; }
	if (!live.length) { return "all mock"; }
	return "live: " + live.join(", ") + " · mock: " + mocked.join(", ");
});
</script>
